import React from 'react';
import PropTypes from 'prop-types';
import { StyledLink } from './styled';

const Link = ({ children, href, target, underline, font, color, onClick }) => {
    return (
        <StyledLink
            href={href}
            target={target}
            underline={underline}
            font={font}
            color={color}
            onClick={onClick}
        >
            {children}
        </StyledLink>
    )
};

Link.propTypes = {
    children: PropTypes.node,
    href: PropTypes.string.isRequired,
    target: PropTypes.string,
    underline: PropTypes.oneOf(['none', 'hover', 'always']),
    font: PropTypes.object,
    color: PropTypes.string,
    onClick: PropTypes.func
};

Link.defaultProps = {
    underline: 'hover',
    target: '_blank',
    onClick: undefined
};

export default React.memo(Link);
